import React, { FC, useMemo, useRef, useState } from 'react';
import { useHistory } from 'react-router';

import { Button } from 'devextreme-react/button';
import DataGrid, {
  Column,
  ColumnChooser,
  FilterPanel,
  FilterRow,
  GroupPanel,
  HeaderFilter,
  Pager,
  Paging,
  StateStoring,
} from 'devextreme-react/data-grid';
import 'devextreme-react/text-area';

import CustomStore from 'devextreme/data/custom_store';
import { maskedPhone } from 'utils/masked-phone';

import { AppCard, AppLayoutTop } from '../../../../components/appComponents';
import ClaimsProvider from '../../../../components/claimsBlock';
import { requestHelper } from '../../../../utils/request-helper';
import { ContractorIndividualAddModal, ContractorIndividualDeleteModal } from './components';

const ContractorIndividualPage: FC = () => {
  const [visible, setVisible] = useState<boolean>(false);
  const [, setOpenId] = useState<number | null>(null);
  const [visibleDelete, setVisibleDelete] = useState<boolean>(false);
  const [openIdDelete, setOpenIdDelete] = useState<number | null>(null);

  const ContractorIndividualDataStore: any = useMemo(
    () =>
      new CustomStore({
        key: 'id',
        load: (loadOptions: any) => requestHelper('/v1/contractorIndividual', 'get', loadOptions),
        insert: async (values) => {
          await requestHelper('/v1/contractorIndividual', 'post', {
            values: values,
          });
        },

        remove: async (key) =>
          await requestHelper(`/v1/contractorIndividual/${key}`, 'delete', {
            key: key,
          }),

        update: async (key, values) =>
          await requestHelper(`/v1/contractorIndividual/${key}`, 'put', {
            key: key,
            values: values,
          }),
      }),
    [],
  );

  const refGrid = useRef<DataGrid | null>(null);
  const history = useHistory();

  return (
    <div className="container-dev">
      <AppLayoutTop title="Физ. лица">
        <ClaimsProvider claimsBlock={['CanCreateIndividualContractor']}>
          <Button
            width={120}
            text="Создать"
            type="default"
            onClick={() => {
              setOpenId(null);
              setVisible(true);
            }}
          />
        </ClaimsProvider>
      </AppLayoutTop>
      <ContractorIndividualAddModal
        id={null}
        visible={visible}
        changeVisible={setVisible}
        refresh={() => refGrid.current?.instance.refresh()}
      />

      <ContractorIndividualDeleteModal
        visible={visibleDelete}
        changeVisible={(show) => setVisibleDelete(show)}
        id={openIdDelete}
        refresh={() => refGrid.current?.instance.refresh()}
      />

      <AppCard>
        <DataGrid
          dataSource={ContractorIndividualDataStore}
          showBorders={false}
          loadPanel={{
            enabled: true,
            text: 'Загрузка',
          }}
          ref={refGrid}
          remoteOperations={true}
          onRowUpdating={(e) => (e.newData = { ...e.oldData, ...e.newData })}
          onInitNewRow={(e) =>
            (e.data = {
              name: '',
              phone: '',
              email: '',
              fault: 0,
              comment: '',
              isProvider: false,
            })
          }
          onRowDblClick={(e) => history.push(`/contractor-detail/${e.data.id}`)}
          allowColumnResizing
          columnResizingMode="nextColumn"
          columnMinWidth={50}
          allowColumnReordering
        >
          <StateStoring enabled={true} type="localStorage" storageKey="contractorIndividual" />
          <FilterRow visible={true} />
          <FilterPanel visible={true} />
          <HeaderFilter visible />
          <GroupPanel visible={true} />
          <ColumnChooser enabled={true} />

          <Column dataField="name" caption="Имя" sortOrder="asc" />
          <Column dataField="phone" caption="Телефон" cellRender={({ data }) => maskedPhone(data.phone)} />
          <Column dataField="email" caption="Email" />
          <Column dataField="isProvider" caption="Поставщик" width={200} />
          <Column dataField="comment" caption="Комментарий" width={200} visible={false} />
          <Column
            dataField=""
            caption=""
            width={150}
            cellRender={(data) => (
              <ClaimsProvider claimsBlock={['CanEditIndividualContractor']}>
                <div>
                  <Button
                    icon="edit"
                    type="default"
                    stylingMode="text"
                    onClick={() => {
                      history.push(`/contractor-detail/${data.data.id}`);
                    }}
                  />
                  <Button
                    icon="trash"
                    type="default"
                    stylingMode="text"
                    onClick={() => {
                      setOpenIdDelete(data.key);
                      setVisibleDelete(true);
                    }}
                  />
                </div>
              </ClaimsProvider>
            )}
          />

          <Paging defaultPageSize={15} />
          <Pager showPageSizeSelector={true} allowedPageSizes={[15, 30, 50, 100]} />
        </DataGrid>
      </AppCard>
    </div>
  );
};

export default ContractorIndividualPage;
